module.exports = __webpack_public_path__ + "img/img-11.d2cf2a7e.png";